import React, { useContext } from 'react'
import { createUseStyles } from 'react-jss'
import cn from 'classnames'
import ResponsiveImage from '../ResponsiveImage'
import { sliceMarginStyles, span } from '../../style/span'
import theme from '../../style/theme'
import { vw } from '../../style/vw'
import get from 'lodash/get'
import ColorContext from '../ColorContext'
import { useSelector } from 'react-redux'
import { getPageSlices } from '../../redux/slices/content'
import last from 'lodash/last'
import Button from '../Button'

const PageHero = ({ className, slice }) => {
  const { title, image, cta, noMargin } = slice
  const slices = useSelector(getPageSlices)
  const { borderColor } = useContext(ColorContext)
  const classes = useStyles({ color: get(image, ['palette', 'dominant', 'title']), borderColor })

  return (
    <section className={cn(classes.section, { withoutImage: !image, withoutMargin: noMargin || last(slices) === slice })}>
      {image && <ResponsiveImage {...image} className={classes.image} parallax={theme.parallax} />}
      <div className={classes.content}>
        {title && (
          <h2 className={classes.title}>
            {title}
          </h2>
        )}
        {cta && <Button link={cta?.[0]} size='sm' uppercase={false} theme='white' className={classes.cta} />}
      </div>
    </section>
  )
}

const useStyles = createUseStyles({
  section: {
    extend: [sliceMarginStyles],
    position: 'relative',
    padding: [0, span(1)],
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
    color: ({ color }) => color || 'currentColor',
    borderColor: ({ borderColor }) => borderColor,
    [theme.breakpoints.up('md')]: {
      padding: [0, span(3, 'md')]
    },

    '&.withoutImage': {
      minHeight: 'auto',
      marginBottom: 0,
      borderBottomWidth: 1,
      borderBottomStyle: 'solid',
      padding: [vw(100), span(1), 0],
      [theme.breakpoints.up('md')]: {
        padding: [0, span(3, 'md')]
      }
    },
    '&.withoutMargin': {
      marginBottom: 0
    }
  },
  image: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    '&:after': {
      content: '""',
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      backgroundColor: 'rgba(51,51,51,0.3)'
    }
  },
  content: {
    zIndex: 10,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  title: {
    margin: [0, 0, vw(20)],
    fontSize: vw(18),
    textAlign: 'center',
    lineHeight: 1.2,

    [theme.breakpoints.up('md')]: {
      margin: [0, 0, vw(20, 'desktop')],
      fontSize: vw(22, 'desktop'),
      width: vw(620, 'desktop')
    },
    '& > *': {
      margin: 0
    }
  },
  cta: {}
}, { name: 'PageHero' })

export default PageHero
